import { RG_TYPE } from '../../types/rg-type.js';
import { DefaultCeiling } from './default-ceiling.js';
import { DefaultFloor } from './default-floor.js';
import { DefaultWall } from './default-wall.js';

const DefaultModule = {
    type: RG_TYPE.Module,
    size: [3.9, 2.5, 7.5],
    anchor: [0.5, 0, 0.5],
    name: 'module',
    children: [
        { ...DefaultWall, pos: [0, 0, -3] },
        { ...DefaultWall, pos: [0, 0, 3], rot: [180, 0, 180] },
        { ...DefaultWall, pos: [-3, 0, 0], rot: [0, 90, 0] },
        { ...DefaultWall, pos: [3, 0, 0], rot: [0, -90, 0] },
        { ...DefaultCeiling },
        { ...DefaultFloor }
    ]
};

export { DefaultModule };
//# sourceMappingURL=default-module.js.map
